export const SET_TASK_LIST = 'SET_TASK_LIST'
export const SET_TASK_LIST_META = 'SET_TASK_LIST_META'
export const SET_TASK_LIST_FILTER_DATA = 'SET_TASK_LIST_FILTER_DATA'

export const TASK_INIT_STATE = {
    taskList: [],
    taskListMeta: {},
    taskListFilterData: {},
};
